import axios from "axios";
import Environment from "./Environment";

class ScholarshipsAPI {

    static scholarshipsApiUrl = `${Environment.apiUrl}/scholarships`;
    static searchScholarships = async (searchPayload: any, page=1) => {

        const apiCompletionPromise = await axios.post(`${Environment.apiUrl}/scholarship-preview/?page=${page}`, searchPayload);

        return apiCompletionPromise;
    };
    static getSlug = async (slug: string) => {

        const apiCompletionPromise = await axios.get(`${Environment.apiUrl}/scholarship-slug/?slug=${slug}`); 

        return apiCompletionPromise;
    };
}

export default ScholarshipsAPI;